import { View, type StyleProp, type ViewStyle } from "react-native";
import { ChevronDown, ChevronUp } from "lucide-react-native";

type CollapsibleChevronButtonProps = {
  expanded: boolean;
  size?: number;
  iconSize?: number;
  color?: string;
  strokeWidth?: number;
  backgroundColor?: string;
  borderColor?: string;
  style?: StyleProp<ViewStyle>;
};

export function CollapsibleChevronButton({
  expanded,
  size = 28,
  iconSize = 15,
  color = "#8D7A6F",
  strokeWidth = 2,
  backgroundColor = "rgba(255,255,255,0.42)",
  borderColor = "rgba(92,52,32,0.08)",
  style,
}: CollapsibleChevronButtonProps) {
  const ChevronIcon = expanded ? ChevronUp : ChevronDown;

  return (
    <View
      style={[
        {
          width: size,
          height: size,
          borderRadius: 999,
          alignItems: "center",
          justifyContent: "center",
          backgroundColor,
          borderWidth: 1,
          borderColor,
          flexShrink: 0,
        },
        style,
      ]}
    >
      <ChevronIcon size={iconSize} color={color} strokeWidth={strokeWidth} />
    </View>
  );
}
